
/* injects from baggage-loader */

import { CharThumbs } from '_appRoot/index.const';

// export const definitonModal = [
//     'Nos quadrinhos, as <b>sarjetas</b> ou <b>calhas são os <b>espaços</b> em branco entre dois quadrinhos. Esses espaços representam um <b>intervalo de tempo</b> entre o acontecimento de um quadro e o acontecimento do quadro seguinte.'
// ]

export const introBallons = [
    'Esta é a estrada de Requadros. Para chegar ao esconderijo de Albedo, Croma saltará por entre as <span><b>sarjetas</b></span> ou <span><b>calhas</b><span>.'
]

export const tutorialBallons = [
    'Para derrotar o Albedo nesta fase, você precisará completar a história com os quadrinhos que estão faltando.',
    'Clique no quadrinho e arraste para o local adequado.'
]

export const dropSuccessBallons = [
    'Muito bem! <br> Albedo está menos poderoso agora. Continue completando o quadrinho!'
]

export const dropFailBallons = [
    'Parece que este quadro não pertence a este espaço.'
]

export const scene1 = [
    {
        bg: require('_images/stages/stage-one/croma-abeldo-dialogs/scene-1.png'),
        text: ['Encontrei você, Albedo!'],
        thumb: CharThumbs.croma,
        visible: false
    },
    {
        bg: require('_images/stages/stage-one/croma-abeldo-dialogs/scene-2.png'),
        text: ['Ahhhhhhhh!!!'],
        thumb: CharThumbs.abeldo,
        visible: false
    },
];

export const scene2 = [
    {
        bg: require('_images/stages/stage-one/croma-abeldo-dialogs/scene-3.png'),
        text: ['Consegui recuperar uma das <b>páginas</b>!'],
        thumb: CharThumbs.croma,
        visible: false
    },
    {
        bg: require('_images/stages/stage-one/croma-abeldo-dialogs/scene-4.png'),
        text: ['Oh, não! Albedo <b>escapou</b> para outro esconderijo!<br> Vamos <b>Continuar</b>!'],
        thumb: CharThumbs.croma,
        visible: false
    },
];

export const feedbackTexts = [
    'As Histórias em quadrinhos são um tipo de arte sequencial, isto é, uma arte em que uma imagem sucede a outra para contar uma história. Isso significa que os quadros devem ser lidos em uma ordem específica.',
    'Nos quadrinhos brasileiros, essa leitura é feita da esquerda para a direita e de cima para baixo. <br> Cada requadro representa o desenrolar de uma ação.',
    'Os tamanhos dos quadros podem indicar maior intensidade da ação. Quadros maiores exigem mais atenção, pois possuem mais detalhes. Quadros menores tendem a representar ações mais rápidas, sem muitos detalhamentos.'
]

export const puzzle = [
    {
        id: 'p1',
        img: require('_images/stages/stage-one/gameplay/01.png')
    },
    {
        id: 'p2',
        img: require('_images/stages/stage-one/gameplay/02.png')
    },
    {
        id: 'p3',
        img: require('_images/stages/stage-one/gameplay/03.png')
    },
    {
        id: 'p4',
        img: require('_images/stages/stage-one/gameplay/04.png')
    },
    {
        id: 'p5',
        img: require('_images/stages/stage-one/gameplay/05.png')
    }
];


// WEBPACK FOOTER //
// ./src/app/pages/stage-one/stage-one.const.js